var $ = require('jquery');

var MatchHeight = require('../functions/match-height');
var Cycle = require('../functions/cycle');
var Dropdown = require('../functions/dropdown');
var PageSlide = require('../functions/page-slide');
var Gallery = require('../functions/gallery');
var Map = require('../functions/map');
var Modal = require('../functions/modal');

$(document).ready(function() {
	new Cycle();
	new Dropdown();
	new PageSlide();
	new MatchHeight();
	new Gallery();
	new Modal();
});

window.initMap = function() {
	new Map();
};